import PriceListView from './price-list-view'

export default PriceListView
